
import React from 'react'
import icon from './svgs/gotoLight.svg'
import { BaseIcon } from './_base'

export const GotoLightIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
